import { useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import { Files, TrashFill } from "react-bootstrap-icons";
import { Controller } from "react-hook-form";
import { FaPen } from "react-icons/fa";
import { NumericFormat } from "react-number-format";
import SelectRegisteredAddress from "../../../../components/Shipment/Address/SelectRegisteredAddress";
import PackageSelect from "../../../../components/Shipment/register/PackageSelect";
import usePackage from "../../../../hooks/usePackage";
import useSharedData from "../../../../hooks/useSharedData";
import Checkbox from "../../../../pages/shop/components/Shipments/components/checkbox/Checkbox";
import calculateMass from "../../../../pages/shop/components/Shipments/functions/calculateMass";
import dimentionsValidations from "../../../../pages/shop/components/Shipments/functions/dimentionsValidations";
import maxWeight from "../../../../pages/shop/components/Shipments/functions/maxWeight";
import NewAddress from "../../../components/addresses/NewAddress";
import weightValidation from "../../newLetter/functions/weight/weightValidation";
import generateRandomString from "../functions/generateRandomString";
import isCod from "../functions/isCod";
import maxCost from "../functions/maxCost";
import PreOrderCodeInput from "./PreOrderCodeInput";
import style from "./ShipmentForm.module.css";

function ShipmentFormBulk({
  index,
  register,
  shipment,
  errors,
  remove,
  getValues,
  control,
  insert,
  watch,
  setValue,
  isDirty,
  unregister,
  priceState: { prices, setPrices },
  lastPartNumber,
  type = 1,
}) {
  const { calculatePackagingPrice } = usePackage();
  const { isAgent, canUsePreOrderCode } = useSharedData();

  const [showNewAddressModal, setShowNewAddressModal] = useState(false);

  const get = value => {
    try {
      return watch("items")[index][value];
    } catch (error) {
      return undefined;
    }
  };

  const getPrice = () => {
    try {
      const item = prices.find(item => item.ui === shipment.ui);
      return {
        price: item.price,
        totalPrice: item.totalPrice,
      };
    } catch (error) {
      return undefined;
    }
  };

  useEffect(() => {
    if (isDirty === true) {
      if (getPrice() !== undefined) {
        setPrices(cur => {
          const index = cur.findIndex(item => item.ui === shipment.ui);
          cur[index].price = 0;
          return [...cur];
        });
      }
    }
  }, [isDirty]);

  const [getterAddressModal, setGetterAddressModal] = useState(false);

  useEffect(() => {
    register(`items.${index}.getterAddress`, {
      value: shipment.getterAddress,
      required: { value: true, message: "آدرس الزامی" },
    });
  }, []);

  useEffect(() => {
    if (isCod() === false) {
      unregister(`items.${index}.amountCOD`);
    }
  }, [isCod()]);

  useEffect(() => {
    if (getPrice() !== undefined) {
      setPrices(cur => {
        const index = cur.findIndex(item => item.ui === shipment.ui);
        cur[index].price = 0;
        return [...cur];
      });
    }
  }, [get("getterAddressId")]);

  useEffect(() => {
    if (isAgent === false) {
      unregister(`items.${index}.serviceInPlace`);
    }
  }, []);

  return (
    <div>
      <div
        className={
          "d-flex flex-wrap position-relative " +
          style.formSection +
          " " +
          (getPrice() !== undefined && getPrice().price === 0
            ? style.shadowRed
            : "")
        }
      >
        <div className={style.partNumberBox}>
          <span>شماره پارت: </span>
          <span>{lastPartNumber + index}</span>
        </div>
        <Col xs={12} sm={6} md={3} lg={2} xxl={1}>
          <Form.Label>
            <span>وزن</span>
            <span>(کیلوگرم):</span>
          </Form.Label>
          <Form.Control
            type="number"
            step="0.0001"
            {...register(`items.${index}.weight`, {
              required: { value: true, message: "وزن الزامی" },
              value: shipment.weight,
              valueAsNumber: true,
              max: maxWeight(type),
              min: { value: 0.05, message: "حداقل وزن 50 گرم" },
              onBlur: type === 1 ? weightValidation : undefined,
            })}
          />
          {errors?.weight && <p>{errors?.weight?.message}</p>}
        </Col>
        <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
          <Form.Label>ابعاد(سانتی متر):</Form.Label>
          <div className="d-flex column-gap-1">
            <Form.Control
              type="number"
              placeholder="طول"
              {...register(`items.${index}.length`, {
                required: { value: true, message: "طول الزامی" },
                value: shipment.length,
                valueAsNumber: true,
                max: { value: 250, message: "حداکثر طول 250 کیلو سانتی متر" },
                min: { value: 1, message: "حداقل طول 1 سانتی متر" },
                onBlur: type === 1 ? dimentionsValidations : undefined,
              })}
            />

            <Form.Control
              type="number"
              placeholder="عرض"
              {...register(`items.${index}.width`, {
                required: { value: true, message: "عرض الزامی" },
                value: shipment.width,
                valueAsNumber: true,
                max: { value: 250, message: "حداکثر عرض 250 کیلو سانتی متر" },
                min: { value: 1, message: "حداقل عرض 1 سانتی متر" },
                onBlur: type === 1 ? dimentionsValidations : undefined,
              })}
            />

            <Form.Control
              type="number"
              placeholder="ارتفاع"
              {...register(`items.${index}.height`, {
                required: { value: true, message: "ارتفاع الزامی" },
                value: shipment.height,
                valueAsNumber: true,
                max: {
                  value: 250,
                  message: "حداکثر ارتفاع 250 کیلو سانتی متر",
                },
                min: { value: 1, message: "حداقل ارتفاع 1 سانتی متر" },
                onBlur: type === 1 ? dimentionsValidations : undefined,
              })}
            />
          </div>
          <div className="d-flex column-gap-1">
            <div className="flex-grow-1">
              {errors?.width && <p>{errors?.width?.message}</p>}
            </div>
            <div className="flex-grow-1">
              {errors?.length && <p>{errors?.length?.message}</p>}
            </div>
            <div className="flex-grow-1">
              {errors?.height && <p>{errors?.height?.message}</p>}
            </div>
          </div>
        </Col>

        <Col xs={12} sm={6} md={4} lg={3} xxl={2}>
          <Form.Label>وضعیت:</Form.Label>

          <div className="d-flex flex-wrap align-items-end mt-2">
            <Controller
              name={`items.${index}.isLiquid`}
              control={control}
              defaultValue={shipment.isLiquid}
              render={({ field: { onChange, value } }) => (
                <Checkbox title="مایعات" onChange={onChange} value={value} />
              )}
            />

            <Controller
              name={`items.${index}.isFragile`}
              control={control}
              defaultValue={shipment.isFragile}
              render={({ field: { onChange, value } }) => (
                <Checkbox
                  title="شکستنی"
                  className="me-3"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </div>
        </Col>

        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Label>نوع بسته بندی:</Form.Label>
          <Controller
            control={control}
            name={`items.${index}.packaging`}
            rules={{
              min: { value: 1, message: "انتخاب نوع بسته بندی الزامی" },
            }}
            render={({ field: { onChange, value } }) => (
              <PackageSelect onChange={onChange} value={value} />
            )}
          />
          {errors?.packaging && <p>{errors?.packaging?.message}</p>}
        </Col>

        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Label>نیاز به بسته بندی:</Form.Label>

          <Controller
            name={`items.${index}.needPackaging`}
            control={control}
            render={({ field: { onChange, value } }) => (
              <Checkbox title="دارم" onChange={onChange} value={value} />
            )}
          />
        </Col>

        <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
          <Form.Label>ارزش اظهار شده کالا:</Form.Label>

          <Controller
            control={control}
            name={`items.${index}.cost`}
            rules={{
              required: { value: true, message: "ارزش کالا الزامی" },
              max: maxCost(type),
            }}
            render={({ field: { ref, onChange } }) => (
              <NumericFormat
                getInputRef={ref}
                suffix="  ريال"
                onValueChange={inputValue => {
                  const { value } = inputValue;
                  onChange(value ? parseInt(value) : undefined);
                }}
                className="form-control"
                value={shipment.cost}
                thousandSeparator={true}
              />
            )}
          />
          {errors?.cost && <p>{errors?.cost?.message}</p>}
        </Col>

        {isCod() === true && (
          <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
            <Form.Label>مبلغ COD:</Form.Label>

            <Controller
              control={control}
              name={`items.${index}.amountCOD`}
              defaultValue={shipment.amountCOD ? shipment.amountCOD : 0}
              rules={{
                required: {
                  value: true,
                  message: "حداقل مبلغ cod صفر است (پسکرایه)",
                },
                min: { value: 0, message: "حداقل مبلغ cod صفر است (پسکرایه)" },
                validate: {
                  codAndCost: v => {
                    if (v > 0) {
                      if (v !== getValues(`items.${index}.cost`)) {
                        return "اگر مرسوله مبلغ cod دارد ، باید با ارزش کالا برابر باشد";
                      }
                    }

                    return true;
                  },
                },
              }}
              render={({ field: { ref, onChange, value } }) => (
                <NumericFormat
                  getInputRef={ref}
                  suffix="  ريال"
                  onValueChange={inputValue => {
                    const { value } = inputValue;
                    onChange(value ? parseInt(value) : undefined);
                  }}
                  className="form-control"
                  value={value}
                  thousandSeparator={true}
                />
              )}
            />
            {errors?.amountCOD && <p>{errors?.amountCOD?.message}</p>}
          </Col>
        )}

        <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
          <Form.Label>خدمات در محل:</Form.Label>
          <Controller
            control={control}
            name={`items.${index}.serviceInPlace`}
            defaultValue={shipment.serviceInPlace}
            rules={{
              min: {
                value: 0,
                message: "حداقل مبلغ 0 ریال",
              },
              max: {
                value: 15_000_000,
                message: "حداکثر مبلغ 1 میلیون 500 هزار تومان",
              },
            }}
            render={({ field: { ref, onChange, value } }) => (
              <NumericFormat
                getInputRef={ref}
                suffix="  ريال"
                onValueChange={inputValue => {
                  const { value } = inputValue;
                  onChange(value !== "" ? parseInt(value) : 0);
                }}
                className="form-control"
                value={value}
                thousandSeparator={true}
              />
            )}
          />
          {errors?.serviceInPlace && <p>{errors?.serviceInPlace?.message}</p>}
        </Col>

        <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
          <Form.Label>محتویات:</Form.Label>
          <Form.Control
            {...register(`items.${index}.content`, {
              required: { value: true, message: "محتویات الزامی" },
              value: shipment.content,
            })}
            placeholder="مثل: کیف"
          />
          {errors?.content && <p>{errors?.content?.message}</p>}
        </Col>

        {isAgent && canUsePreOrderCode && (
          <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
            <Form.Label>کد پیش سفارش:</Form.Label>
            <Controller
              name={`items.${index}.preOrderCode`}
              control={control}
              rules={{
                minLength: { value: 6, message: "کد پیش سفارش اشتباه است" },
              }}
              render={({ field: { value, onChange, ref } }) => (
                <PreOrderCodeInput
                  value={value}
                  onChange={onChange}
                  ref={ref()}
                />
              )}
            />
            {errors?.preOrderCode && <p>{errors?.preOrderCode?.message}</p>}
          </Col>
        )}

        <div className="w-100">
          <Form.Label>
            <button
              className="buttonUi btn-success-style"
              style={{ width: 180 }}
              onClick={() => setGetterAddressModal(true)}
              type="button"
            >
              <div className="d-flex align-items-center">
                <span>انتخاب آدرس گیرنده</span>
                <span className="me-2">
                  <FaPen />
                </span>
              </div>
            </button>
          </Form.Label>
          <input
            type="number"
            className={style.inputHidden}
            {...register(`items.${index}.getterAddressId`, {
              value: shipment.getterAddressId,
              required: { value: true, message: "آدرس الزامی" },
            })}
          />
          <Form.Control
            as="textarea"
            disabled={true}
            value={
              get("getterAddress")
                ? `کد پستی: ${get("getterAddress")?.postCode ?? ""}\nآدرس: ${
                    get("getterAddress")?.totalAddress
                  }`
                : ""
            }
          />

          {(!get("getterAddress") || !get("getterAddressId")) && (
            <p>{errors?.getterAddress?.message}</p>
          )}
        </div>

        <div className="w-100 d-flex flex-wrap column-gap-4">
          <p className="text-secondary fs-6">
            <strong>وزن حجمی: </strong>
            <strong>
              {calculateMass({
                width: get("width"),
                height: get("height"),
                length: get("length"),
              })}
            </strong>
          </p>
          <p className="text-secondary fs-6">
            <strong>هزینه بسته بندی: </strong>
            <strong>
              {calculatePackagingPrice({
                type: get("packaging"),
                width: get("width"),
                height: get("height"),
                length: get("length"),
                need: get("needPackaging"),
              }).toLocaleString()}
            </strong>
          </p>
        </div>

        <div className="w-100 d-flex flex-wrap justify-content-between align-items-center mt-1 mt-md-2">
          {getPrice() !== undefined &&
            (() => {
              const { price, totalPrice } = getPrice();
              return (
                <>
                  <p className="fs-5 text-black pe-md-4">
                    <span>قیمت بارکد پستی: </span>
                    <span className="fs-4 text-primary fw-bold">
                      {isNaN(price) ? "0" : price?.toLocaleString()}
                    </span>
                    <span> ریال</span>
                  </p>
                  <p className="fs-5 text-black pe-md-4">
                    <span>قیمت نهایی: </span>
                    <span className="fs-4 text-primary fw-bold">
                      {isNaN(totalPrice) ? "0" : totalPrice?.toLocaleString()}
                    </span>
                    <span> ریال</span>
                  </p>
                </>
              );
            })()}
          <div className="me-auto">
            <button
              className="buttonUi"
              type="button"
              onClick={() => {
                setPrices(cur => cur.filter(item => item.ui !== shipment.ui));
                remove(index);
              }}
            >
              <span>
                <TrashFill color="red" />
              </span>
            </button>

            <button
              className="buttonUi"
              type="button"
              onClick={() =>
                insert(index + 1, {
                  ...getValues("items")[index],
                  ui: generateRandomString(),
                })
              }
            >
              <span>
                <Files color="blue" />
              </span>
            </button>
          </div>
        </div>
      </div>

      {getterAddressModal && (
        <SelectRegisteredAddress
          senderOrgetter={1}
          onClose={() => setGetterAddressModal(false)}
          onSelect={address => {
            setValue(`items.${index}.getterAddressId`, address.id);
            setValue(`items.${index}.getterAddress`, address);
            setGetterAddressModal(false);
          }}
          onNewAddressClick={() => {
            setGetterAddressModal(false);
            setShowNewAddressModal(true);
          }}
        />
      )}

      {showNewAddressModal && (
        <NewAddress
          senderOrgetter={1}
          onClose={() => setShowNewAddressModal(false)}
          setResult={({ address }) => {
            setValue(`items.${index}.getterAddressId`, address.id);
            setValue(`items.${index}.getterAddress`, address);
            setShowNewAddressModal(false);
          }}
        />
      )}
    </div>
  );
}

export default ShipmentFormBulk;
